// ======================================================================
// File Name       : ContentDocumentList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button } from 'react-bootstrap';
import * as contentConstant from '../../constants/ContentConstant';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import { DATA_AFFIILIATION_TYPE_TEXT } from '../../constants/ContentConstant';
import ReduxFormPaging from '../ReduxFormPaging';
import { Col } from 'react-bootstrap';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import { CONTENT_DOCUMENT_DETAIL } from '../../constants/PathConstants';

const thead = [
  { title: 'コンテンツ識別ID', sortBy: 0},
  { title: 'コンテンツ名', sortBy: 1 , width:'30%'},
  { title: '外部', sortBy: 2, width:'5%'},
  { title: '登録日時', sortBy: 8},
  { title: '登録者', sortBy: null}, //Step 9.0.0
  { title: 'ステータス', sortBy: 3},
  { title: '操作', sortBy: null, width:'100'},
];

class ContentDocumentList extends React.Component {
  render() {
    const {
      documentContentList,
      goToDetail,
      handleSortState,
      invalid,
      handleMouseEnter,
      handleMouseLeave,
      recordNum,
      getStartEndData,
    } = this.props;
    const { bySecernId, allSecernIds } = documentContentList;
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="documentSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {allSecernIds && allSecernIds.map((contentSecernId, index) => {
              const {
                  contentName,
                  documentUpdateStatus,
                  dataAffiliationType,
                  createdAt,
                  contentIcon,
                  createdUserName, //Step 9.0.0
              } = bySecernId[
                    contentSecernId
              ];
              const documentIdAndIcon = (<i className={contentIcon}> {contentSecernId}</i>);
              const changeDocumentUpdateStatus = (type) => {
                try {
                  const typeInt = parseInt(type, 10);
                  return contentConstant.DocumentUpdateType[typeInt].name;
                } catch (error) {
                  return type;
                }
              };
              const link = CONTENT_DOCUMENT_DETAIL.replace(':id', contentSecernId);
              return (
                <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
                  <td>
                    <div> {contentSecernId} </div>
                  </td>
                  <td>
                    {contentName}
                  </td>
                  <td>
                    {getItemBoxName(DATA_AFFIILIATION_TYPE_TEXT, dataAffiliationType)}
                  </td>
                  <td>
                    {parseDateForDetail(createdAt)}
                  </td>
                  {/* Step 9.0.0 START */}
                  <td>
                    {createdUserName}
                  </td>
                  {/* Step 9.0.0 END */}
                  <td>
                    {changeDocumentUpdateStatus(documentUpdateStatus)}
                  </td>
                  <td className="text-center">
                    <CustomLink
                      className="margin-right-7 link-detail-edit"
                      to={link}
                      text="詳細"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Col className="d-flex justify-content-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
            invalid={invalid}
          />
        </Col>
      </div>
    );
  }
}

export default ContentDocumentList;
